import * as React from 'react';
import {IChannel} from '../../../../data/api/models';
import {find, get} from 'lodash';
import * as Commonmark from 'react-commonmark';

interface IFooterProps {
    channel: IChannel;
}

export default class Footer extends React.Component<IFooterProps, any> {
    public render() {
        const {channel} = this.props;

        const privacyUrl = get(channel, 'urls.privacyCookies', '');
        const cookiesUrl = get(channel, 'urls.privacyCookies', '');

        const policyDocument = find(channel.productDocuments, (document) => {
            return document.shortName === 'Terms of Business';
        });

        const termsOfBusiness = policyDocument ? policyDocument.filePath : '';

        return (
            <footer>
                <div className="container">
                    <Commonmark source={channel.footer || ''}/>
                    {channel.key !== 'npo-b2c' && channel.key !== 'cspa-b2c' && (
                        <div className="links">
                            <a href={termsOfBusiness} target="_blank">
                                terms of business
                            </a>
                            {channel.key !== 'camc-b2c' ? (
                                <a href={cookiesUrl} target="_blank">
                                    cookie policy
                                </a>
                            ) : (
                                <a href="https://www.pjhayman.com/cookie-policy/" target="_blank">
                                    cookie policy
                                </a>
                            )}

                            <a href={privacyUrl} target="_blank">
                                privacy policy
                            </a>
                            <a href={channel.urls.contactUs} target="_blank">
                                contact us
                            </a>
                        </div>
                    )}
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Footer/index.tsx